"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CreditsText = void 0;
var _react = _interopRequireDefault(require("react"));
var _creditStyles = require("./creditStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CreditsText = ({
  category,
  title,
  name,
  link
}) => _react.default.createElement(_react.default.Fragment, null, !!category && _react.default.createElement(_creditStyles.Category, null, category), _react.default.createElement(_creditStyles.Content, null, _react.default.createElement(_creditStyles.Title, null, title, ": "), !link && _react.default.createElement(_creditStyles.Name, null, name) || _react.default.createElement(_creditStyles.Link, {
  href: link,
  target: "_blank",
  rel: "noreferrer"
}, _react.default.createElement(_creditStyles.Name, null, name))));
exports.CreditsText = CreditsText;
const Credits = ({
  text,
  buttonText,
  buttonUrl,
  credits
}) => _react.default.createElement(_creditStyles.Container, null, _react.default.createElement("div", null, _react.default.createElement(_creditStyles.CtaText, null, text), _react.default.createElement(_creditStyles.Cta, {
  href: buttonUrl,
  target: "_blank",
  rel: "noreferrer"
}, _react.default.createElement("p", {
  className: "bricks-cta"
}, buttonText))), _react.default.createElement("div", null, credits.map(credit => _react.default.createElement(CreditsText, credit))));
var _default = Credits;
exports.default = _default;
//# sourceMappingURL=CtaCredits.js.map